import { mediaEventUpOnce, getMediaEvent2006Ext } from './eventUp';
import { trackEvent } from './track';

export const getOnelinkUrl = () => {
    try {
        const link = window.adv.getDeeplinkURLByBID('FINTECH_APP');

        if (link) {
            trackEvent('fin_outcast_generate_onelink_url_success_st', {
                onelink_url: link
            });

            return link;
        } else {
            trackEvent('fin_outcast_generate_onelink_url_fail_st', {
                error_msg: 'getDeeplinkURLByBID link is null'
            });
        }
    } catch (e: unknown) {
        const errorMessage = (e as Error)?.message; // Type assertion

        trackEvent('fin_outcast_generate_onelink_url_fail_st', {
            error_msg: errorMessage
        });
    }
};

export const clickConversionButton = (button: string, params:object) => {
    // 广告上报：最终转化
    const linkUrl = getOnelinkUrl();

    if (linkUrl) {
        window.location.href = linkUrl;
    } else {
        console.error('getOnelinkUrl failed');
    }
};
